import React, { useId } from 'react'
import { useForm } from 'react-hook-form'

import { LntButton, LntForm, LntFormItem, LntModal, LntModalFooter, LntSelect } from '@app/components/base'

import { BUTTON_TYPE, SIZE } from '@app/constants'

import type { ProductMergeFormData, ProductMergeModalProps } from './types'

export const ProductMergeModal: React.FC<ProductMergeModalProps> = props => {
  const { options, onSubmit, ...modalProps } = props

  const form = useForm<ProductMergeFormData>()
  const formId = useId()

  const handleSubmit = (): void => {
    const { selectedGeneralId } = form.getValues()

    if (selectedGeneralId) {
      onSubmit(selectedGeneralId)
    }
  }

  return (
    <LntModal
      { ...modalProps }
      footer={ null }
      width={ 444 }
    >
      <LntForm<ProductMergeFormData>
        layout='vertical'
        onSubmit={ handleSubmit }
        formInstance={ form }
        id={ formId }
      >
        <LntFormItem
          name='selectedGeneralId'
          label='Выберите основной товар'
          defaultValue={ [] }
          validationOptions={ { rules: { required: true } } }
        >
          <LntSelect options={ options } />
        </LntFormItem>
      </LntForm>

      <LntModalFooter>
        <LntButton
          type={ BUTTON_TYPE.primary }
          size={ SIZE.middle }
          form={ formId }
          disabled={ !form.formState.isValid }
          htmlType='submit'
        >
          Продолжить
        </LntButton>
      </LntModalFooter>
    </LntModal>
  )
}
